import axios from '/src/common/axios'
import Utils from '/src/common/utils';

export default {
  getPoll: function () {
    return axios.get('/api/poll/getpoll', { })
  },
  savePoll: function (data) {
    return axios.post('/api/poll/savePoll', data)
  },    
  getRelationTypeList: function() {
    return axios.get('/api/nsi/relationType')
  },
  getDistrictList: function() {
    return axios.get('/api/nsi/districtListNN')
  },
  saveTmpPatient: function (data) {
    return axios.post('/api/poll/saveTmpPatient', data)
  },    
  exportFile: function(uid) {
    return Utils.downloadFile('/api/poll/exportFile?uid='+uid, "TestResult.docx")
  },
  getResultForUser: function() {
    return axios.get('/api/poll/getResultForUser')
  }
}